import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { AuthState, User } from '../types';
import { apiService } from '../services/api';

interface AuthStore extends AuthState {
  setAuth: (user: User, accessToken: string, refreshToken: string) => void;
  updateUser: (user: User) => void;
  clearAuth: () => void;
  login: (email: string, password: string) => Promise<void>;
  signup: (userData: { firstName: string; lastName: string; email: string; password: string }) => Promise<void>;
  refreshCurrentUser: () => Promise<void>;
}

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      isAuthenticated: false,
      
      setAuth: (user: User, accessToken: string, refreshToken: string) =>
        set({
          user,
          accessToken,
          refreshToken,
          isAuthenticated: true,
        }),
      
      updateUser: (user: User) =>
        set((state) => ({
          ...state,
          user,
        })),
      
      clearAuth: () =>
        set({
          user: null,
          accessToken: null,
          refreshToken: null,
          isAuthenticated: false,
        }),

      login: async (email: string, password: string) => {
        const response = await apiService.login(email, password);
        const { user, access_token } = response.data;
        
        set({
          user,
          accessToken: access_token,
          refreshToken: access_token,
          isAuthenticated: true,
        });
      },

      signup: async (userData) => {
        await apiService.signup(userData);
      },

      refreshCurrentUser: async () => {
        try {
          const response = await apiService.getCurrentUser();
          const user = response.data;
          
          set((state) => ({
            ...state,
            user,
          }));
        } catch (error) {
          console.error('Failed to refresh user data:', error);
        }
      },
    }),
    {
      name: 'asf-panel-auth',
      partialize: (state) => ({
        user: state.user,
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);